// extracted by mini-css-extract-plugin
export default {"wrapper":"Links_wrapper__9NwOa","container":"Links_container__h6UUf","align":"Links_align__dBCfh","link":"Links_link__HWDl3","title":"Links_title__gWfwb"};